import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../shared/services/user/user.service';
import { ConfirmEmailModel } from '../../../model/ConfirmEmailModel';
import { NotificationService } from '../../../shared/services/notification.service';
import { TranslatorService } from '../../../core/translator/translator.service';
import { LoadingContainer, LoadingPage } from '../../../shared/LoadingContainer';
import { AppSettingsService } from '../../../shared/services/appsettings.service';

@Component({
    selector: 'app-useremailconfirm',
    template: require('./confirmemail.component.html'),
    //styles: [require('./changepassword.component.scss')]
})
export class ConfirmEmailComponent extends LoadingPage {

    model = new ConfirmEmailModel();
    public confirmed = true;

    constructor(
        public settings: AppSettingsService,
        private userService: UserService,
        private route: ActivatedRoute,
        private router: Router,
        protected notificationService: NotificationService,
        private translateService: TranslatorService) {
        super(true);
    }

    ngOnInit() {        
        this.model.UserId = this.route.snapshot.params['id'];
        this.model.ConfirmationCode = this.route.snapshot.params['confirmationCode'];

        this.userService.confirmEmail(this.model).then(response => {          
            this.confirmed = true;
            this.ready();
            this.notificationService.showSuccess('app.notification.SUCCESS', 'confirmemail.notification.CONFIRMATION_SUCCESS');            
        })
            .catch(e => {
                this.confirmed = false;
                this.ready();
                this.notificationService.handleGlobalErrors(e)
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/routes/pages/register/confirmemail.component.ts